import { normDateToShortAmericanDate } from "../../../helpers/dateFormatters";
import React from 'react';


import { createStyles } from "./styles";






var GroupInfoSection = function GroupInfoSection(_ref) {var groupInfo = _ref.groupInfo,type = _ref.type;
  var classes = createStyles();
  return /*#__PURE__*/(
    React.createElement("div", { className: classes.groupSection }, /*#__PURE__*/
    React.createElement("h3", { className: classes.groupName }, groupInfo.groupName), /*#__PURE__*/
    React.createElement("p", { className: classes.groupInfo },
    type === 'template' && /*#__PURE__*/React.createElement("b", null, "Valid Till:"),
    (type === 'browsing' || type === 'renewal') && /*#__PURE__*/React.createElement("b", null, "Effective Date:"), /*#__PURE__*/
    React.createElement("span", null,
    groupInfo.effectiveDate ? normDateToShortAmericanDate(groupInfo.effectiveDate) : '')), /*#__PURE__*/


    React.createElement("p", { className: classes.groupInfo }, /*#__PURE__*/
    React.createElement("b", null, "Address:"), /*#__PURE__*/
    React.createElement("span", null, groupInfo.address))));



};

export default GroupInfoSection;
//# sourceMappingURL=index.js.map